var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitationsIconItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57489 2.08985L0.986974 9.74901C0.892381 9.91282 0.842331 10.0985 0.841801 10.2877C0.841271 10.4769 0.890281 10.6629 0.983955 10.8272C1.07763 10.9916 1.2127 11.1285 1.37573 11.2244C1.53876 11.3204 1.72407 11.3719 1.91322 11.374H11.0891C11.2782 11.3719 11.4635 11.3204 11.6265 11.2244C11.7896 11.1285 11.9246 10.9916 12.0183 10.8272C12.112 10.6629 12.161 10.4769 12.1605 10.2877C12.1599 10.0985 12.1099 9.91282 12.0153 9.74901L7.42739 2.08985C7.33083 1.93065 7.19486 1.79904 7.03262 1.70769C6.87038 1.61635 6.68733 1.56836 6.50114 1.56836C6.31495 1.56836 6.1319 1.61635 5.96966 1.70769C5.80741 1.79904 5.67145 1.93065 5.57489 2.08985Z",
    stroke: "#DA3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50098 4.875V7.04167",
    stroke: "#DA3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50098 9.20898H6.50808",
    stroke: "#DA3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitationsIconItem);
export default __webpack_public_path__ + "static/media/limitations-icon-item.469bc732635ed797277fb6b05e85be25.svg";
export { ForwardRef as ReactComponent };